import { Injectable } from '@angular/core';
import {
  CommonStandardServiceStackForm,
  CommonStandardServiceStackFormComponent,
  CommonUserServiceStackFormComponent,
  CommonUserServiceStackForm,
  COMMON_USER_SERVICE_STACK_FORM_FEATURE_NAME,
  COMMON_STANDARD_SERVICE_STACK_FORM_FEATURE_NAME,
  OBJECT_STORAGE_SERVICE_STACK_FORM_FEATURE_NAME,
  ObjectStorageServiceStackFormComponent,
  ObjectStorageServiceStackForm,
  LocalStorageServiceStackForm,
  LocalStorageServiceStackFormComponent,
  LOCAL_STORAGE_SERVICE_STACK_FORM_FEATURE_NAME
} from '@zerops/zerops/feature/service-stack-add-form/modules';
import { ServiceStackTypeCategories } from '@zerops/models/service-stack';

const CATEGORY_RESOLVER = {
  [ServiceStackTypeCategories.Standard]: {
    formInstance: CommonStandardServiceStackForm,
    formComponent: CommonStandardServiceStackFormComponent,
    translationKey: COMMON_STANDARD_SERVICE_STACK_FORM_FEATURE_NAME
  },
  [ServiceStackTypeCategories.User]: {
    formInstance: CommonUserServiceStackForm,
    formComponent: CommonUserServiceStackFormComponent,
    translationKey: COMMON_USER_SERVICE_STACK_FORM_FEATURE_NAME
  },
  [ServiceStackTypeCategories.ObjectStorage]: {
    formInstance: ObjectStorageServiceStackForm,
    formComponent: ObjectStorageServiceStackFormComponent,
    translationKey: OBJECT_STORAGE_SERVICE_STACK_FORM_FEATURE_NAME
  },
  [ServiceStackTypeCategories.LocalStorage]: {
    formInstance: LocalStorageServiceStackForm,
    formComponent: LocalStorageServiceStackFormComponent,
    translationKey: LOCAL_STORAGE_SERVICE_STACK_FORM_FEATURE_NAME
  }
};

@Injectable({ providedIn: 'root' })
export class ServiceStackAddFormResolverService {

  resolve<F = any, C = any>(
    type: string,
    version: string,
    category?: string
  ): { formInstance: F; formComponent: C; translationKey: string } {
    const resolved = CATEGORY_RESOLVER[category] || CATEGORY_RESOLVER[ServiceStackTypeCategories.User];

    if (!resolved) {
      throw new Error(`Service Stack Add resolver for type ${type} and ${version} (category: ${category}) doesn't exist.`);
    }

    return resolved;
  }

}
